module.exports = __webpack_public_path__ + "static/media/menu-customer-blue.367c0954.svg";